export default __webpack_public_path__ + "static/media/neurallanguage_tensorflow.18ce4145.png";